import * as React from 'react';

import * as styles from './styles.css';
import { ErrorButton } from '../../views/GroupsSection/ErrorButton';

interface IErrorComponentProps {
  recallFailed(): void;
}

export const ErrorComponent: React.FC<IErrorComponentProps> = ({ recallFailed }) => {
  return (
    <div className={styles['error_container']}>
      <ErrorButton callback={recallFailed}>
        Произошла ошибка.
        <span className={styles['error_button']}>Попробуйте снова</span>
      </ErrorButton>
    </div>
  );
};
